import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
import Fill from "ol/style/Fill";
import Circle from "ol/style/Circle";
import Text from "ol/style/Text";
import Icon from "ol/style/Icon";
import Point from 'ol/geom/Point';
const selectStyleCache = {}
const styleCache = {}
const styleCacheBig = {}
const iconRadius = 14
let shadowStyle = null;
let shadowStyleFirstGeom = null;

/* select style for ol.interaction.Select control */
export const defaultSelectStyle = new Style(
    {
        stroke: new Stroke({
            color: '#f00',
            width: 4
        }),
        fill: new Fill({
            color: 'rgba(255,0,0,0.1)'
        }),
        image: new Circle({
            radius: iconRadius,
            fill: new Fill({
                color: 'black'
            }),
            stroke: new Stroke({
                color: [255, 0, 0],
                width: 2
            })
        }),
        geometry: function (feature) {
            var selectindex = feature.get("selectIndex")
            if (feature.get("features") && typeof selectindex === "number") {
                return feature.get("features")[selectindex].getGeometry()
            } else if (feature.get("features") && feature.get("features").length === 1) {
                return feature.get("features")[0].getGeometry()
            } else {
                return feature.getGeometry()
            }

        }
    });



function createShadowStyle(radius) {
    var canvas = document.createElement('canvas');
    canvas.width = radius * 2;
    canvas.height = radius * 2;
    var context = canvas.getContext("2d");
    var centerX = radius;
    var centerY = radius;

    context.beginPath();
    var rad = context.createRadialGradient(centerX, centerY, radius / 3, centerX, centerY, radius);
    rad.addColorStop(0, 'rgba(40, 40, 40, 0.8)');
    rad.addColorStop(1, 'rgba(40, 40, 40, 0.1)');
    context.fillStyle = rad;

    context.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
    // context.fillStyle = "rgba(100, 100, 100, 0.4)";
    context.fill();
    var pngUrl = canvas.toDataURL(); // PNG is the default

    var style = new Style({
        image: new Icon({
            anchor: [0.3, 0.3],
            size: [radius * 2, radius * 2],
            src: pngUrl,
            imgSize: [radius * 2, radius * 2]
        })


    });

    return style;

}

function createShadowStyleFirstGeom(radius) {
    var canvas = document.createElement('canvas');
    canvas.width = radius * 2;
    canvas.height = radius * 2;
    var context = canvas.getContext("2d");
    var centerX = radius;
    var centerY = radius;

    context.beginPath();
    var rad = context.createRadialGradient(centerX, centerY, radius / 3, centerX, centerY, radius);
    rad.addColorStop(0, 'rgba(40, 40, 40, 0.8)');
    rad.addColorStop(1, 'rgba(40, 40, 40, 0.1)');
    context.fillStyle = rad;

    context.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
    // context.fillStyle = "rgba(100, 100, 100, 0.4)";
    context.fill();
    var pngUrl = canvas.toDataURL(); // PNG is the default

    var style = new Style({
        image: new Icon({
            anchor: [0.3, 0.3],
            size: [radius * 2, radius * 2],
            src: pngUrl,
            imgSize: [radius * 2, radius * 2]
        }),
        geometry: function (feature) {
            return new Point(feature.getGeometry().getFirstCoordinate())
        }

    });

    return style;

}

shadowStyle = createShadowStyle(iconRadius);
shadowStyleFirstGeom = createShadowStyleFirstGeom(iconRadius);


function addGeometryStyle(feature, monument_type, styleArray, color) {
    //var color = (monument_type === "gm") ? gmColor : rmColor
    switch (feature.getGeometry().getType()) {

        case "Polygon":
        case "MultiPolygon":
            styleArray.push(new Style({
                zIndex: -1,
                stroke: new Stroke({
                    color: 'rgba(' + color + ',0.5)',
                    width: 2
                }),
                fill: new Fill({
                    color: 'rgba(' + color + ',0.3)'
                }),
                geometry: function (feature) {
                    return (feature.get("features")) ? feature.get("features")[0].getGeometry() : feature.getGeometry()
                }
            }))
            break;
        case "LineString":
        case "MultiLineString":
            styleArray.push(new Style({
                zIndex: -1,
                stroke: new Stroke({
                    color: 'rgba(' + color + ',0.5)',
                    width: 6
                }),
                fill: new Fill({
                    color: 'rgba(' + color + ',0.3)'
                }),
                geometry: function (feature) {
                    return (feature.get("features")) ? feature.get("features")[0].getGeometry() : feature.getGeometry()
                }
            }))
    }
}

/**
 * creates a cluster style for the given size.
 * the size is display as text
 * @param size number of features
 * @returns
 */
function createClusterStyle(size) {
    return [shadowStyle, new Style({
        image: new Circle({
            radius: iconRadius,

            fill: new Fill({
                color: '#96003F'
            })
        }),
        text: new Text({
            font: "bold 12px serif",
            text: size.toString(),
            fill: new Fill({
                color: '#fff'
            })
        })
    })];
}

function createIconStyle(imagePath, feature, img, colorHex, color) {
    var styles = []
    var monument_type = feature.get("typedID").substr(0, 2)
    //var color = (monument_type === "gm") ? gmColor : rmColor

    if (!feature) {
        return;
    }
    var radiosExt = Math.floor(Math.sqrt(0.5 * Math.pow(iconRadius, 2)))
    addGeometryStyle(feature, monument_type, styles, color)
    styles.push(shadowStyle)
    styles.push(new Style({
        zIndex: 2000,
        image: new Circle({
            radius: iconRadius,
            stroke: new Stroke({
                color: 'rgb(' + color + ')',
                width: 2
            }),
            fill: new Fill({
                color: 'rgba(255,255,255,1)'
            })
        })

    }))
    styles.push(new Style({
        zIndex: 2000,
        image: new Icon({
            anchor: [0.5, 0.6],
            //size : [ iconRadius*2, iconRadius*2 ],
            scale: radiosExt * 2 / 32,
            src: imagePath,
            //img: img,
            //color: colorHex,
            //imgSize: [32, 32]
        }),
        geometry: function (feature) {
            return (feature.get("features")) ? feature.getGeometry() : new Point(feature.getGeometry().getFirstCoordinate())
        }
    }))
    return styles
}


function createIconStyleFirstGeom(imagePath, feature, img, colorHex, color) {
    var styles = []
    var monument_type = feature.get("typedID").substr(0, 2)
    //var color = (monument_type === "gm") ? gmColor : rmColor

    if (!feature) {
        return;
    }
    var radiosExt = Math.floor(Math.sqrt(0.5 * Math.pow(iconRadius, 2)))
    addGeometryStyle(feature, monument_type, styles, color)
    styles.push(shadowStyleFirstGeom)
    styles.push(new Style({
        zIndex: 2000,
        image: new Circle({
            radius: iconRadius,
            stroke: new Stroke({
                color: 'rgb(' + color + ')',
                width: 2
            }),
            fill: new Fill({
                color: 'rgba(255,255,255,1)'
            })
        }),
        geometry: function (feature) {
            return new Point(feature.getGeometry().getFirstCoordinate())
        }
    }))
    styles.push(new Style({
        zIndex: 2000,
        image: new Icon({
            anchor: [0.5, 0.6],
            //size : [ iconRadius*2, iconRadius*2 ],
            scale: radiosExt * 2 / 32,
            src: imagePath,
            //img: img,
            //color: colorHex,
            //imgSize: [32, 32]
        }),
        geometry: function (feature) {
            return new Point(feature.getGeometry().getFirstCoordinate())
        }
    }))
    return styles
}

/**
 * ol style function for styling monuments.
 * featureIn could be a cluster feature or a monument feature
 * @param featureIn
 * @param resolution
 * @returns
 */
function monumentStyleFunction(featureIn, resolution) {

    var features = featureIn.get('features'), size = 1, feature = null, clusterStyleName = null;

    // if feature is from cluster source all real features are stored in
    // 'features'
    // if not 'features' available we assume the it is a real feature not
    // from cluster source
    // so we can switch the vector layer source without modifying the style
    // function
    if (features) {
        size = features.length;
        clusterStyleName = "cluster_" + size
        // we use cluster style
        if (size > 1) {
            if (!styleCache[clusterStyleName]) {
                styleCache[clusterStyleName] = createClusterStyle(size);
            }
            return styleCache[clusterStyleName];
        } else {
            // we use normal styling with the only feature in cluster feature
            feature = features[0];
        }
    } else {
        feature = featureIn;
    }

    //styling a single feature
    //properties we need
    var soort = feature.get("soortID")
    var monument_type = feature.get("typedID").substr(0, 2)
    var geometryType = feature.getGeometry().getType()
    var styleCacheKey = monument_type + "_" + soort + "_" + geometryType

    //if in cache return
    if (styleCache[styleCacheKey]) {
        return styleCache[styleCacheKey];
    }
    if (soort) {
        var iconStyle = createIconStyle("/soort/" + monument_type + "/" + soort + "/icon", feature, null, this.colors_hex[monument_type], this.colors[monument_type]);
    } else {
        var iconStyle = []
        var colorDefaultStyle = this.colors[monument_type];//(monument_type === "gm") ? gmColor : rmColor;

        addGeometryStyle(feature, monument_type, iconStyle, this.colors[monument_type])
        iconStyle.push(shadowStyle)
        iconStyle.push(new Style({
            image: new Circle({
                radius: iconRadius,
                fill: new Fill({
                    color: 'rgb(' + this.colors[monument_type] + ')'
                }),
                stroke: new Stroke({
                    color: 'rgb(' + + this.colors[monument_type] + + ')',
                    width: 2
                })
            })

        }))
    }


    styleCache[styleCacheKey] = iconStyle;

    return styleCache[styleCacheKey];

}



/**
 * ol style function for styling monuments.
 * featureIn could be a cluster feature or a monument feature
 * @param featureIn
 * @param resolution
 * @returns
 */
function monumentBigStyleFunction(featureIn, resolution) {

    var size = 1, feature = featureIn, clusterStyleName = null;



    //styling a single feature
    //properties we need
    var soort = feature.get("soortID")
    var monument_type = feature.get("typedID").substr(0, 2)
    var geometryType = feature.getGeometry().getType()
    var styleCacheKey = monument_type + "_" + soort + "_" + geometryType

    //if in cache return
    if (styleCacheBig[styleCacheKey]) {
        return styleCacheBig[styleCacheKey];
    }

    if (soort && this.hasIcon[monument_type][soort]) {
        var iconStyle = createIconStyleFirstGeom("/soort/" + monument_type + "/" + soort + "/icon", feature, null, this.colors_hex[monument_type], this.colors[monument_type]);
    } else {
        var iconStyle = []
        var colorDefaultStyle = this.colors[monument_type];//(monument_type === "gm") ? gmColor : rmColor;

        addGeometryStyle(feature, monument_type, iconStyle, this.colors[monument_type])
        //iconStyle.push(shadowStyleFirstGeom);
        /*
        iconStyle.push(new Style({
            image: new Circle({
                radius: iconRadius,
                fill: new Fill({
                    color: 'rgb(' + this.colors[monument_type] + ')'
                }),
                stroke: new Stroke({
                    color: 'rgb(' + + this.colors[monument_type] + + ')',
                    width: 2
                })
            }),
            geometry: function (feature) {
                return new Point(feature.getGeometry().getFirstCoordinate())
            }

        }))
        */
    }


    styleCacheBig[styleCacheKey] = iconStyle;

    return styleCacheBig[styleCacheKey];

}

function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? "" + parseInt(result[1], 16) + "," + parseInt(result[2], 16) + "," + parseInt(result[3], 16)
        : null;
}

export function styleFunc(config) {
    var colorMap = {
        colors: {},
        colors_hex: {}
    };
    config.layerconfig.forEach(function (lc) {
        colorMap.colors[lc.name.toLowerCase()] = hexToRgb(lc.color);
        colorMap.colors_hex[lc.name.toLowerCase()] = lc.color;
    });
    return monumentStyleFunction.bind(colorMap);
}

export function styleBigFunc(config) {
    var colorMap = {
        colors: {},
        colors_hex: {},
        hasIcon: {}
    };
    config.layerconfig.forEach(function (lc) {
        colorMap.colors[lc.name.toLowerCase()] = hexToRgb(lc.color);
        colorMap.colors_hex[lc.name.toLowerCase()] = lc.color;
        colorMap.hasIcon[lc.name.toLowerCase()] = {}
        config['soort' + lc.name].forEach(function (soort) {
            colorMap.hasIcon[lc.name.toLowerCase()][soort.id] = (soort.icondata !== "")
        });
    });

    return monumentBigStyleFunction.bind(colorMap);

}

